import { Box } from '@mui/material';
import type { ComponentType } from 'react';
import type { ActionWithRulesAndAddersProps, ValueEditorProps } from 'react-querybuilder';
import {
  AddConditionAction,
  AddGroupAction,
  ConditionDragHandle,
  ConditionFieldSelector,
  ConditionValueSelector,
  RemoveConditionAction,
  RemoveGroupAction,
} from './conditions-builder-controls';

/** Every control of a condition row except the value editor, which each screen brings. */
export const CONDITION_CONTROLS = {
  addRuleAction: AddConditionAction,
  addGroupAction: AddGroupAction,
  dragHandle: ConditionDragHandle,
  fieldSelector: ConditionFieldSelector,
  operatorSelector: ConditionValueSelector,
  combinatorSelector: ConditionValueSelector,
  valueSelector: ConditionValueSelector,
  removeRuleAction: RemoveConditionAction,
  removeGroupAction: RemoveGroupAction,
};

/** `+ Group`, left out of groups that already sit at the deepest level the screen allows. */
export function createAddGroupAction(maxGroupLevel?: number | null) {
  const LimitedAddGroupAction = (props: ActionWithRulesAndAddersProps) =>
    maxGroupLevel !== null &&
    maxGroupLevel !== undefined &&
    props.level >= maxGroupLevel ? null : (
      <AddGroupAction {...props} />
    );
  return LimitedAddGroupAction;
}

/** Gives any value editor the row's value cell, so a screen's own editor lines up with the rest. */
export function withConditionValueCell<Props extends ValueEditorProps>(
  ValueEditor: ComponentType<Props>,
) {
  const ConditionValueCell = (props: Props) => (
    <Box className={props.className} data-testid="condition-value" sx={{ minWidth: 0 }}>
      <ValueEditor {...props} />
    </Box>
  );
  ConditionValueCell.displayName = `ConditionValueCell(${ValueEditor.displayName ?? ValueEditor.name})`;
  return ConditionValueCell;
}
